/**
 * @var {module:animation.module:easing~Easing} linear Анимация без ускорения (линейное изменение параметра)
 * @memberof module:animation.module:easing
 */

function easeIn(t, b, c, d) {
    return c * t / d + b;
}

function easeOut(t, b, c, d) {
    return c * t / d + b;
}

function easeInOut(t, b, c, d) {
    return c * t / d + b;
}

export {easeIn, easeOut, easeInOut};